import { Bars } from "react-loader-spinner";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import Chart from "../../Chart/Chart";
import { authContext } from "../../Context/Authentication/authContext";
import "./MSATab.scss";
import { baseURL, dataScienceURL } from "../../config";
import {
  generateChartData,
  getAdjustedPredictionData,
  getAdjustedSentimentData,
  mergeChartData,
} from "../../Helpers/helpers";
import WChart from "../../WhatIfAnalysis/Chart/Chart";

const MSATab = (props: any) => {
  const { tabType, dataType } = props;
  const { state }: any = useContext(authContext);
  const [chartData, setChartData]: any = useState([]);
  const [title, setTitle]: any = useState(tabType);
  const [isLoading, setLoading]: any = useState(true);
  const [chartTitle, setChartTitle]: any = useState("Monthly Home Sales");
  const [percentageTooltip, setPercentageTooltip]: any = useState(false);
  const [isAdjustedPrediction, setIsAdjustedPrediction]: any = useState(false);

  useEffect(() => {
    setChartData([]);
    if (state.filters.predictionsArray.length != 0 && state?.selectedTab != 'Months of Supply' && state.filters.homeSalesArray.length === 1 && state.filters.homeSalesArray.includes('total_sales')) {
      setIsAdjustedPrediction(true);
      getAllPredictionData();
    }
    else if (
      state.filters.homeSalesArray.length == 0 &&
      state?.selectedTab == "Home sales"
    ) {
      setChartData([]);
    }
    else if (
      state.filters.homeSalesArray.length != 0 &&
      state?.selectedTab == "Home sales"
    ) {
      setIsAdjustedPrediction(false);
      getAllHomeSalesData()
    }
    // if (state.filters.refreshAdjustedPredictionSubmit ) {
    //   setIsAdjustedPrediction(true)
    //   getAdjustedPrediction()
    // }
    // else if (state.filters.refreshAdjustedSentimentSubmitByConsumer  && state.filters.zipcode?.length === 0) {
    //   console.log('jkplll')
    //   setIsAdjustedPrediction(true)
    //   getAdjustedSentiment('consumer')
    // }
    // else if (state.filters.refreshAdjustedSentimentSubmitByBuilder  && state.filters.zipcode?.length === 0) {
    //   console.log('jkp')
    //   setIsAdjustedPrediction(true)
    //   getAdjustedSentiment('builder')
    // }
    else {
      
      setIsAdjustedPrediction(false);
      apiCall(tabType);
    }
  }, [
    state.filters.years,
    state.filters.msa,
    state.filters.value,
    state?.filters?.selectedType,
    state.filters.refreshAdjustedPredictionSubmit,
    state.filters.refreshAdjustedSentimentSubmitByConsumer,
    state.filters.refreshAdjustedSentimentSubmitByBuilder,
    state.filters.rentalValue,
    state.filters.homeSalesArray
  ]);

  const getAllHomeSalesData = async () => {
    if (state.filters.homeSalesArray.length === 0) return;
    
    setLoading(true);
    let combinedData = [];
    const msa = Array.isArray(state.filters.msa) 
    ? state.filters.msa
        .filter((m:any) => m && m.name) // Filter out null/undefined items or items without a name
        .map((m:any) => m.name)
    : [];
    const formattedArray = msa.map((item: any) => `'${item}'`).join(",");
    const start = state.filters.years[0];
    const end = state.filters.years[1];
  
    try {
      // Create an array of promises for each async call
      const promises = state.filters.homeSalesArray.map(async (t: any) => {
        let url = baseURL;
        url = `${url}getHomeSalesMetroCities?state=${
          state.filters.state
        }&metroarea=${formattedArray}&startYear=${start}&endYear=${end}&flag=${state.filters.value.toLowerCase()}&category=${t}`;
        
        const response = await axios.get(url);
        return {
          category: t,
          data: generateChartData(response.data?.cube, dataType)
        };
      });
      
      // Wait for all promises to resolve
      const results = await Promise.all(promises);
      
      // Process the results
      setChartTitle("Compare Home Sales");
      console.log(results)
      
      // Merge the data for chart rendering
      const mergedData = mergeChartData(results,state.filters.msa);

      console.log(mergedData)
      setChartData(mergedData);
    } catch (error) {
      console.error("Error fetching home sales data:", error);
    } finally {
      setLoading(false);
    }
  };


  const getAllPredictionData = () => {
    if (state.filters.predictionsArray.length != 0) {
      let mainarr: any = [];
      let res1: any = [];
      let res2: any = [];
      let res3: any = [];

      // Create an array of promises for each async call
      const promises = state.filters.predictionsArray.map(async (t: any) => {
        if (t == "Mortgage Rates") {
          const msa = state.filters.msa[0].name;
          const query = `${state.filters.state}/${msa}/metro`;
          let data = state.filters.adjustedPredictionValues;
          delete data.status;
          let type = "";
          if (tabType === "Home sales") {
            type = "hs";
            setChartTitle("Adjusted MSA HS Projection  ");
          } else if (tabType === "Days on market") {
            type = "dom";
            setChartTitle("Adjusted MSA DOM Projection  ");
          } else if (tabType === "MSP") {
            type = "msp";
            setChartTitle("Adjusted MSA MSP Projection  ");
          } else if (tabType === "Price") {
            type = "ppsf";
            setChartTitle("Adjusted MSA PPSF Projection  ");
          }

          res1 = await getAdjustedPredictionData(query, data, type);
          console.log(res1, "resp1");
        } else if (t == "Consumer Sentiments(HPSI)") {
          let type = "consumer";
          const msa = state.filters.msa[0].name;
          const query = `${state.filters.state}/${msa}/metro`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          let Type = "";

          if (tabType === "Home sales") {
            Type = "hs";
            setChartTitle("Adjusted MSA HS Projection  ");
          } else if (tabType === "Days on market") {
            Type = "dom";
            setChartTitle("Adjusted MSA DOM Projection  ");
          } else if (tabType === "MSP") {
            Type = "msp";
            setChartTitle("Adjusted MSA MSP Projection  ");
          } else if (tabType === "Price") {
            Type = "ppsf";
            setChartTitle("Adjusted MSA PPSF Projection  ");
          }
          res2 = await getAdjustedSentimentData(query, data, `${Type}/consumer`)
          console.log(res2, "resp2");
        } else if (t == "Builder Sentiments(NAHB)") {
          let type = "builder";
          const msa = state.filters.msa[0].name;
          const query = `${state.filters.state}/${msa}/metro`;
          let data =
            type === "consumer"
              ? state.filters.adjustedSentimentValuesByConsumer
              : state.filters.adjustedSentimentValuesByBuilder;
          delete data.status;
          let Type = "";

          if (tabType === "Home sales") {
            Type = "hs";
            setChartTitle("Adjusted MSA HS Projection  ");
          } else if (tabType === "Days on market") {
            Type = "dom";
            setChartTitle("Adjusted MSA DOM Projection  ");
          } else if (tabType === "MSP") {
            Type = "msp";
            setChartTitle("Adjusted MSA MSP Projection  ");
          } else if (tabType === "Price") {
            Type = "ppsf";
            setChartTitle("Adjusted MSA PPSF Projection  ");
          }
          res3 = await getAdjustedSentimentData(query, data, `${Type}/builder`)
          console.log(res3, "resp3");
        }
      });

      // Wait for all promises to resolve
      Promise.all(promises)
        .then(() => {
          if (res1.length > 0) {
            res1.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction:
                  res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction:
                  res3[index]?.adjusted_prediction || "",
              });
            });
          } else if (res2.length > 0) {
            res2.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction:
                  res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction:
                  res3[index]?.adjusted_prediction || "",
              });
            });
          } else if (res3.length > 0) {
            res3.forEach((item: any, index: any) => {
              mainarr.push({
                date: item.date,
                actual_predictions: item.actual_predictions,
                adjusted_prediction: res1[index]?.adjusted_prediction || "",
                consumer_adjusted_prediction:
                  res2[index]?.adjusted_prediction || "",
                builder_adjusted_prediction:
                  res3[index]?.adjusted_prediction || "",
              });
            });
          }

          console.log(mainarr);
          setChartData(mainarr);
          setLoading(false);
        })
        .catch((error) => {
          console.error("Error occurred:", error);
        });
    }
  };

  const getAdjustedPrediction = async () => {
    const msa = state.filters.msa[0].name;
    const query = `${state.filters.state}/${msa}/metro`;
    let data = state.filters.adjustedPredictionValues;
    delete data.status;
    let type = "";
    if (tabType === "Home Sales") {
      type = "hs";
      setChartTitle("Adjusted MSA HS Projection  ");
    } else if (tabType === "Days On Market") {
      type = "dom";
      setChartTitle("Adjusted MSA DOM Projection  ");
    } else if (tabType === "MSP") {
      type = "msp";
      setChartTitle("Adjusted MSA MSP Projection  ");
    } else if (tabType === "Price") {
      type = "ppsf";
      setChartTitle("Adjusted MSA PPSF Projection  ");
    }

    const resp = await getAdjustedPredictionData(query, data, type);
    setChartData(resp);
    setLoading(false);
  };

  const getAdjustedSentiment = async (sentimenttype: string) => {
    const msa = state.filters.msa[0].name;
    const query = `${state.filters.state}/${msa}/metro`;
    let data = state.filters.adjustedPredictionValues;
    delete data.status;
    let type = "";

    if (tabType === "Home sales") {
      type = "hs";
      setChartTitle("Adjusted MSA HS Projection  ");
    } else if (tabType === "Days On Market") {
      type = "dom";
      setChartTitle("Adjusted MSA DOM Projection  ");
    } else if (tabType === "MSP") {
      type = "msp";
      setChartTitle("Adjusted MSA MSP Projection  ");
    } else if (tabType === "Price") {
      type = "ppsf";
      setChartTitle("Adjusted MSA PPSF Projection  ");
    }
    const resp = await getAdjustedSentimentData(
      query,
      data,
      `${type}/${sentimenttype}`
    );

    setChartData(resp);
  };

  const apiCall = async (tabType: string) => {
    setPercentageTooltip(false);
    const start = state.filters.years[0];
    const end = state.filters.years[1];
    let url = baseURL;
    let removeExtraFlags = false;
    if (tabType === "Home sales") {
      setChartTitle("Monthly Home Sales");
      url = `${url}getHomeSalesMetroCities`;
    } else if (tabType === "Days on market") {
      url = `${url}getDaysOnMarketMetroCities`;
      setChartTitle("Days on Market");
    } else if (tabType === "MSP") {
      url = `${url}getMSPMetroCities`;
      setChartTitle("Monthly Median Sale Price");
      if (state.filters.value.toLowerCase() === "percentage") {
        setPercentageTooltip(true);
        removeExtraFlags = true;
        url = `${baseURL}getMSPMetroPctChange`;
        setChartTitle("Monthly Median Sale Price in Growth Percentage Change");
      }
    } else if (tabType === "Price") {
      setChartTitle("Median Price Per Square Feet in $,");
      url = `${url}getPPSFMetroCities`;
      if (state.filters.value.toLowerCase() === "percentage") {
        setPercentageTooltip(true);
        removeExtraFlags = true;
        url = `${baseURL}getPPSFMetroPctChange`;
        setChartTitle(
          "Median Price Per Square Feet in Growth"
        );
      }
    } else if (tabType === "Months of Supply") {
      setChartTitle("Months of Supply");
      url = `${dataScienceURL}getMonthsOfSupplyMetro`;
    }
    else if (tabType === "Rentals") {
      setChartTitle("Rentals");
      url = `${dataScienceURL}getRentalDataByMetro`;
    }

    const msa = state.filters.msa.map((m: any) => m.name);
    const formattedArray = msa.map((item: any) => `'${item}'`).join(",");
    setTitle(tabType);
    if (removeExtraFlags)
      url = `${url}?state=${state.filters.state}&metroarea=${formattedArray}`;
    else {
      let flag = state.filters.value.toLowerCase();
      let category = state.filters.rentalValue
      if (tabType === "Months of Supply") {
        url = `${url}?state=${state.filters.state}&metroarea=${formattedArray}&flag=${flag}&startYear=${start}&endYear=${end}`;
      } 
      else if (tabType === "Rentals") {
        url = `${url}?state=${state.filters.state}&metroarea=${formattedArray}&category=${category}&startYear=${start}&endYear=${end}`;
      } else {
        url = `${url}?state=${state.filters.state}&metroarea=${formattedArray}&flag=${state.filters.value.toLowerCase()}&startYear=${start}&endYear=${end}`;
      }
    }

    try {
      const response = await axios.get(url);
      const data = generateChartData(
        response.data?.cube,
        dataType,
        removeExtraFlags
      );
      setChartData(data);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };
  const getSelectValue=()=>{
    switch(state.filters.value){
      case 'Absolute':
        return 'Absolute'
      case 'growth':
          return ' Growth (Month on Month)'
      case 'trend':
            return 'Long Term Trend'
     case 'percentage':
              return 'Percentage'
      
    }
  }

  return (
    <div className="msa-main prediction-chart">
      {chartData?.length && !isAdjustedPrediction ? (
        <div className="msa-main__text">{chartTitle} {getSelectValue()}</div>
      ) : null}

      <div className="msa-main__chartContainer">
        {isLoading ? (
          <div className="msa-main__chartContainer__isLoading">
            <Bars
              height="400"
              ariaLabel="bars-loading"
              wrapperClass="tab-spinner-progress-bar"
              visible={true}
            />
          </div>
        ) : chartData?.length ? (
          <>
            {isAdjustedPrediction ? (
              <WChart
                chartData={chartData}
                chartId={"metro-chart"}
                title={chartTitle}
                isMulti
                isPredition
                isSetToZoom
              />
            ) : (
              <Chart
              chartData={chartData}
              title={`${title} ${
                ["growth"].includes(state.filters.value)
                  ? "(% Growth (Month on Month))"
                  : ["MSP", "Price"].includes(title)
                  ? "($)"
                  : ""
              }`}
              city={Array.isArray(state.filters.msa) && state.filters.msa.length > 0
                ? state.filters.msa
                    .filter((m:any) => m && m.alias) // Filter out null/undefined items or items without alias
                    .map((m:any) => `${m.alias} ${m.type === "Metro" ? "MSA" : "μSA"}`)
                    .sort()
                : []} // Return empty array if msa is empty or not an array
              zipcode={state.filters.zipcode}
              showInterval={state.filters.showInterval}
              customTooltip
              percentageTooltip={percentageTooltip}
              percentageType={percentageTooltip ? dataType.toUpperCase() : ""}
            />
            )}
          </>
        ) : (
          <div className="msa-main__chartContainer__noData">
            No Data Available
          </div>
        )}
      </div>
    </div>
  );
};

export default MSATab;